var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-wrapper"},[_c('i',{class:[
      'icon_com',
      'comicon_seqfront',
      'icon_asc',
      { 'icon-select': _vm.value === 'ascending' }
    ]}),_c('i',{class:[
      'icon_com',
      'comicon_seqend',
      'icon_desc',
      { 'icon-select': _vm.value === 'descending' }
    ]})])}
var staticRenderFns = []

export { render, staticRenderFns }